import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./AboutUsSection.css";
import bgImage from "../asset/image1.jpg"; // Replace with your correct image path

const AboutUsSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false }); // once: false for in-out effect
  }, []);

  return (
    <section id="about-us">
      <div
        className="about-section"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div
          className="about-inner"
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-easing="ease-in-out"
        >
          <h1>About Us</h1>
          <p className="about-text">
            Studying in Europe can be a great opportunity to gain a high-quality education,
            experience a different culture, and explore new horizons. The admission procedures,
            fees, and available universities can vary depending on the country you choose.
            However, I can provide you with a general overview of the process and some popular
            universities in Europe.
            <br />
            <br />
            At <strong>Zenito Ventures</strong>, we specialize in guiding students toward
            their dreams of studying abroad. We offer a complete suite of services, including
            visa processing, university selection, application assistance, and coaching for
            exams such as IELTS, TOEFL, and GMAT. Our experienced counselors provide
            personalized guidance to help students choose the ideal program, country, and
            university that match their aspirations and career goals.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
